export const actionTypes = {
  CATCH_ERROR: 'APP.REQUEST_ERRORS.CATCH_ERROR',
  CLEAR_ERRORS_STORE: 'APP.REQUEST_ERRORS.CLEAR_ERRORS_STORE',
};

export function catchError({ errorCode }) {
  return {
    type: actionTypes.CATCH_ERROR,
    payload: errorCode,
  };
}

export function clearErrorsStore() {
  return {
    type: actionTypes.CLEAR_ERRORS_STORE,
  };
}
